function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: 0,
  x2: 431,
  y1: 256,
  y2: 256
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#87f1fc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: .2557,
  stopColor: "#7fd4fb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: .5295,
  stopColor: "#78bcfb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: .7844,
  stopColor: "#74aefa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#73a9fa"
}));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Capa_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 511.999 511.999",
  style: {
    "enableBackground": "new 0 0 511.999 511.999"
  },
  xmlSpace: "preserve"
}, props), _ref, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "url(#a)"
  },
  d: "M104.967,511.999c-0.104,0-0.209-0.001-0.313-0.001c-38.47-0.21-69.77-31.983-69.77-70.829 V70.058c0-25.691,13.39-48.512,35.819-61.041c22.429-12.531,48.88-11.971,70.758,1.497l302.4,186.405 c20.869,12.848,33.305,35.16,33.255,59.678c-0.05,24.52-12.576,46.781-33.507,59.55L224.997,449.999 c-9.405,5.758-21.695,2.802-27.452-6.602c-5.758-9.404-2.802-21.694,6.602-27.452l218.639-133.869 c9.139-5.576,14.378-14.886,14.4-25.56c0.022-10.673-5.179-20.004-14.268-25.601L120.517,44.511 c-9.374-5.771-20.718-6.011-30.339-0.636c-9.62,5.375-15.364,15.162-15.364,26.183v371.112c0,18.385,15.541,30.819,30.056,30.898 c4.735,0.001,10.08-1.726,15.553-5.064c9.411-5.743,21.698-2.768,27.441,6.645c5.743,9.413,2.767,21.698-6.645,27.441 C129.517,508.23,116.989,511.998,104.967,511.999z"
}));

export default __webpack_public_path__ + "static/media/play.154201f4.svg";
export { SvgComponent as ReactComponent };